import { themeConfig } from '@acast-tech/echo-theme';
import type { ThemeConfig } from 'antd';

/**
 * Shared Ant Design theme for Echo controls. Extends the Echo package theme with
 * dashboard-specific overrides; wrap with `<ConfigProvider theme={echoTheme}>`
 * and read values via `theme.useToken()`.
 */
export const echoTheme: ThemeConfig = {
  ...themeConfig,
  token: {
    ...themeConfig.token,
  },
  components: {
    ...themeConfig.components,
    Select: {
      borderRadius: themeConfig.token?.borderRadiusSM,
      controlHeight: themeConfig.token?.controlHeightLG,
    },
    DatePicker: {
      ...themeConfig.components?.DatePicker,
      borderRadius: themeConfig.token?.borderRadiusSM,
      controlHeight: themeConfig.token?.controlHeightLG,
      colorBorder: themeConfig.token?.colorBorder,
      presetsWidth: 140,
    },
    Segmented: {
      trackBg: themeConfig.token?.colorBgLayout,
      itemSelectedBg: themeConfig.token?.colorPrimary,
      itemSelectedColor: themeConfig.token?.colorTextLightSolid,
      // Echo's disabled text (0.56) is almost the same as enabled text (0.88); fade it for Segmented only.
      colorTextDisabled: 'rgba(1, 9, 28, 0.25)',
      trackPadding: 2,
      borderRadiusLG: themeConfig.token?.borderRadiusLG,
    },
    Tabs: {
      titleFontSize: themeConfig.token?.fontSizeLG,
    },
  },
};
